import React from 'react'

export const TransactionsStyles: { [key: string]: React.CSSProperties } = {
    container: { paddingRight: 27, paddingLeft: 27 },
    header: { paddingTop: 30, paddingBottom: 25 },
    itemContent: {
        width: '100%',
        display: 'flex',
        marginBottom: 10,
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer',
    },
    itemInfoContent: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    itemIconContent: {
        width: 50,
        height: 50,
        display: 'flex',
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
    },
    itemText: { marginLeft: 20 },
}
